import React from 'react';
import { images, stats, highlights } from '../mock';

const About = () => {
  return (
    <section id="about" className="bg-[#ede6d8] py-24 md:py-32">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5 fade-up">
            <div className="image-frame aspect-[4/5] w-full max-w-[260px] sm:max-w-[300px] mx-auto lg:mx-0 lg:max-w-[340px]">
              <img
                src={images.landscape}
                alt="Native bush-covered islands off the New Zealand coast"
                loading="lazy"
              />
            </div>
          </div>

          <div className="lg:col-span-7 fade-up">
            <div className="eyebrow label-caps mb-6">The approach</div>
            <h2 className="font-serif text-[#201d1a] text-[36px] md:text-[52px] leading-[1.06] tracking-tight">
              Real management experience, without the full-time overhead.
            </h2>

            <div className="mt-8 space-y-5 text-[16px] leading-[1.75] text-[#4a423b] max-w-[620px]">
              <p>
                I built Trusted Hands NZ on a simple idea: most small and growing businesses don&apos;t need another full-time manager — they need the <em className="italic text-[#a4514a]">right</em> few hours from someone who has done the job before.
              </p>
              <p>
                The focus is management and operations — working alongside owners on a flexible contract of five to fifteen hours a week to bring order to the moving parts — systems, people, projects, procurement and the numbers.
              </p>
              <p>
                A trusted pair of hands for the hard, unglamorous work of getting things running — calmly, quietly, and leaving your business better than I found it.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-2 border border-[#d9d0c1]">
              {stats.map((s, i) => (
                <div
                  key={s.label}
                  className={`px-5 py-6 ${i < 1 ? 'border-r border-[#d9d0c1]' : ''}`}
                >
                  <div className="font-serif text-[#a4514a] text-[30px] md:text-[36px] leading-none">
                    {s.value}
                  </div>
                  <div className="label-caps text-[#6b625a] mt-3">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="about-highlights">
              {highlights.map((h, i) => (
                <div
                  key={h.title}
                  data-testid={`about-highlight-${i}`}
                  className="bg-[#f6f1e7] border border-[#d9d0c1] border-l-4 border-l-[#a4514a] px-5 py-5"
                >
                  <div className="font-serif text-[#201d1a] text-[20px] leading-tight">{h.title}</div>
                  <p className="mt-2 text-[14px] leading-[1.6] text-[#4a423b]">{h.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
